import React from 'react';
import { LabBreadcrumbs } from '../../../components/breadcrumbs/LabBreadcrumbs';
import { LabSectionList } from './components';
import styles from './Labs.module.scss';
import { ScreenTitle } from 'src/components/design-system';
import { ViewSelector } from 'src/components/common/view-selector';
import classnames from 'classnames';
import { usePageTitle } from 'src/components/app/use-page-title';

const LabsPageComponent = React.memo(
  ({
    id,
    category = {},
    children = null,
    isReady = false,
    showBreadcrumbs = false,
    isRoot = false,
    workspaceName,
  }) => {
    const { pathParts = [], fullPath, workspaceId } = category;
    const title = isRoot ? workspaceName : category.title;

    const { updateSubtitle } = usePageTitle();

    React.useEffect(() => {
      updateSubtitle(title);
    }, [title, updateSubtitle]);

    return (
      <div className={classnames([styles.root, 'new-design-system'])}>
        <div className={styles.header}>
          <div className={styles.headerTitle}>
            {showBreadcrumbs && (
              <LabBreadcrumbs
                title={title}
                pathParts={pathParts}
                initialWorkspaceId={workspaceId}
              />
            )}
            <ScreenTitle title={title} />
          </div>
          <ViewSelector />
        </div>
        <LabSectionList list={children} fullPath={fullPath} isReady={isReady} id={id} />
      </div>
    );
  },
);

export { LabsPageComponent };
